import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	loadingLabel: {
		id: 'software-board-create.flyout-menu.flyout-menu-content.flyout-menu-content-fallback.loading-label',
		defaultMessage: 'Loading',
		description: 'The aria-label for the dropdown item that is loading.',
	},
});
